import { Box, Button, Grid2, IconButton, Tab, Tabs, Typography } from '@mui/material';
import { Field, FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { Grid_Gap, Input_Width, Input_Width_LG } from '../../shared/constants';
import { useLmsDropdownOptions } from '../addlms/option/LsmOption';
import CustomDivider from '../../shared/utils/CustomDivider';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { useAssesmentDropdownOptions } from '../addlms/option/AssesmentOption';
import CustomAccordion from '../../shared/components/accordian/CustomAccordion';
import { FormikEditableText } from '../../shared/components/formfields/FormikEditableText';
import AddIcon from '@mui/icons-material/Add';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import React from 'react'
import ToggleSwitch from '../../shared/utils/CustomToggle';
import RadioButtonGroup from '../../shared/components/formfields/RadioButtonGroup';
import { Icon } from '@iconify/react/dist/iconify.js';
import CustomOurlineAccordian from '../../shared/components/accordian/CustomOurlineAccordian';
import IndexComponent from '../../shared/components/IndexComponent';
import ClearIcon from '@mui/icons-material/Clear';
import { useMutation } from '@tanstack/react-query';
import { postCreateAssessment } from '../../assets/nodeApi/postApi/postAdminApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { RadioCorrectField } from '../../shared/components/formfields/RadioCorrectField';

const CreatAssesments = () => {

    const { showToaster } = useToaster();

    const initialValues = {
        "assessment": {
            "assessmentName": "",
            "type": "",
            "subjectId": "",
            "boardId": "",
            "gradeId": "",
            "academicYear": "",
            "status": "DRAFT",
            "courseId": ""
        },
        "parameters": [
            {
                "parameter": "",
                'maxMarks': "",
                "description": "",
                "details": [
                    {
                        "performanceLevel": "Below_Average",
                        "minScore": "",
                        "maxScore": "",
                        "descriptor": ""
                    },
                    {
                        "performanceLevel": "Average",
                        "minScore": "",
                        "maxScore": "",
                        "descriptor": ""
                    },
                    {
                        "performanceLevel": "Above_Average",
                        "minScore": "",
                        "maxScore": "",
                        "descriptor": ""
                    }
                ]
            }

        ],
        "recommendations": [
            {
                "minScore": "",
                "maxScore": "",
                "category": "Below_Average",
                "timeline": "0 Weeks",
                "recommendation": "",
                "grades": [
                    {
                        "gradeName": "",
                        "gradeTags": [
                        ]
                    }
                ]
            },
            {
                "minScore": "",
                "maxScore": "",
                "category": "Average",
                "timeline": "0 Weeks",
                "recommendation": "",
                "grades": [
                    {
                        "gradeName": "",

                        "gradeTags": [

                        ]
                    }
                ]
            },
            {
                "minScore": "",
                "maxScore": "",
                "category": "Above_Average",
                "timeline": "0 Weeks",
                "recommendation": "",
                "grades": [
                    {
                        "gradeName": "",

                        "gradeTags": [
                        ]
                    }
                ]
            }

        ],

        "questionPapers": [
            {
                "paperName": "",
                "paperNo": 1,
                "sections": [
                    {
                        "title": "",
                        "totalMarks": "",
                        "orderNo": 1,
                        "isVisible": true,
                        "paragraph": "",
                        "questions": [
                            {
                                "questionType": "",
                                "descriptiveType": "",
                                "questionText": "",
                                "marks": "",
                                "orderNo": 1,
                                "options": [
                                    { "optionText": "", "isCorrect": false, "orderNo": 1 }
                                ],
                                "subQuestionHeading": "",
                                "subQuestions": [
                                    {
                                        "questionText": "",

                                    }
                                ]
                            }

                        ]
                    }
                ]
            }
        ],

    };

    const DEFAULT_DETAILS = [
        { performanceLevel: "Below_Average", minScore: 0, maxScore: 0, descriptor: "" },
        { performanceLevel: "Average", minScore: 0, maxScore: 0, descriptor: "" },
        { performanceLevel: "Above_Average", minScore: 0, maxScore: 0, descriptor: "" },
    ];

    const MCQ_QUESTION = {
        questionType: "MCQ",
        questionText: "",
        marks: 0,
        orderNo: 1,
        options: [
            { optionText: "", isCorrect: false, orderNo: 1 },
            { optionText: "", isCorrect: false, orderNo: 2 },
            { optionText: "", isCorrect: false, orderNo: 3 },
            { optionText: "", isCorrect: false, orderNo: 4 },
        ],
    };

    const DESCRIPTIVE_INDIVIDUAL = {
        questionType: "DESCRIPTIVE",
        descriptiveType: "INDIVIDUAL",
        questionText: "",
        marks: 0,
        orderNo: 1,
    };

    const DESCRIPTIVE_CHOICE_BASED = {
        questionType: "DESCRIPTIVE",
        descriptiveType: "CHOICE_BASED",
        questionText: "",
        marks: 0,
        orderNo: 1,
        subQuestionHeading: "",
        subQuestions: [{ questionText: "" }],
    };

    const validationSchema = Yup.object({
        /* ---------------- ASSESSMENT ---------------- */

        assessment: Yup.object({
            assessmentName: Yup.string().required("Assessment name is required"),
            type: Yup.string().required("Type is required"),
            subjectId: Yup.string().required("Subject is required"),
            boardId: Yup.string().required("Board is required"),
            gradeId: Yup.string().required("Grade is required"),
            academicYear: Yup.string().required("Academic year is required"),
            status: Yup.string().required(),
            courseId: Yup.string().required()
        }),

        /* ---------------- PARAMETERS ---------------- */

        parameters: Yup.array().of(
            Yup.object({
                parameter: Yup.string().required("Parameter name is required"),
                maxMarks: Yup.number()
                    .min(1, "Max marks must be greater than 0")
                    .required("Max marks is required"),
                description: Yup.string().required("Description is required"),

                details: Yup.array().of(
                    Yup.object({
                        performanceLevel: Yup.string().required(),
                        minScore: Yup.number().required("Min score is required"),
                        maxScore: Yup.number()
                            .moreThan(Yup.ref("minScore"), "Max must be greater than Min")
                            .required("Max score is required"),
                        descriptor: Yup.string().required("Descriptor is required"),
                    })
                ),
            })
        ),


        /* ---------------- RECOMMENDATIONS ---------------- */

        recommendations: Yup.array().of(
            Yup.object({

                minScore: Yup.number()
                    .min(0, "Min score must be >= 0")
                    .required("Min score is required"),

                maxScore: Yup.number()
                    .moreThan(Yup.ref("minScore"), "Max score must be greater than Min score")
                    .required("Max score is required"),

                category: Yup.string().required("Category is required"),

                timeline: Yup.string().required("Timeline is required"),

                recommendation: Yup.string().required("Recommendation is required"),

                grades: Yup.array().of(
                    Yup.object({

                        // gradeName: Yup.string().when("gradeTags", {
                        //     is: (tags) => tags && tags.length > 0,
                        //     then: s => s.required("Grade name is required"),
                        //     otherwise: s => s.notRequired(),
                        // }),

                        // gradeTags: Yup.array().when("gradeName", {
                        //     is: (name) => !!name,
                        //     then: () =>
                        //         Yup.array()
                        //             .min(1, "At least one grade tag is required")
                        //             .required("Grade tags are required"),
                        //     otherwise: () => Yup.array().notRequired(),
                        // }),

                    })
                ),

            })
        ),


        /* ---------------- QUESTION PAPERS ---------------- */


        questionPapers: Yup.array().of(
            Yup.object({
                paperName: Yup.string().required("Paper name is required"),

                sections: Yup.array().of(
                    Yup.object({
                        title: Yup.string().required("Section title is required"),

                        totalMarks: Yup.number()
                            .min(1, "Total marks must be > 0")
                            .required("Total marks required"),

                        questions: Yup.array()
                            .of(
                                Yup.object({
                                    questionType: Yup.string().required("Question type required"),
                                    descriptiveType: Yup.string().nullable(),

                                    marks: Yup.number()
                                        .min(1, "Marks must be > 0")
                                        .required("Marks required"),

                                    /* ================= MCQ ================= */

                                    questionText: Yup.string().when("questionType", {
                                        is: "MCQ",
                                        then: s => s.required("Question text is required"),
                                        otherwise: s => s.notRequired(),
                                    }),

                                    options: Yup.array().when("questionType", {
                                        is: "MCQ",
                                        then: () =>
                                            Yup.array()
                                                .of(
                                                    Yup.object({
                                                        optionText: Yup.string().required("Option text is required"),
                                                        isCorrect: Yup.boolean(),
                                                    })
                                                )
                                                .min(2, "At least 2 options required")
                                                // .test(
                                                //   "one-correct",
                                                //   "At least one correct option is required",
                                                //   options => options?.some(o => o.isCorrect)
                                                // )
                                                .required("Options are required"),
                                        otherwise: () => Yup.array().notRequired(),
                                    }),

                                    /* =========== DESCRIPTIVE NORMAL =========== */

                                    questionText: Yup.string().when(
                                        ["questionType", "descriptiveType"],
                                        {
                                            is: (qt, dt) => qt === "DESCRIPTIVE" && dt !== "CHOICE_BASED",
                                            then: s => s.required("Question text is required"),
                                            otherwise: s => s.notRequired(),
                                        }
                                    ),

                                    /* =========== DESCRIPTIVE CHOICE BASED =========== */

                                    subQuestionHeading: Yup.string().when(
                                        ["questionType", "descriptiveType"],
                                        {
                                            is: (qt, dt) => qt === "DESCRIPTIVE" && dt === "CHOICE_BASED",
                                            then: s => s.required("Sub question heading is required"),
                                            otherwise: s => s.notRequired(),
                                        }
                                    ),

                                    subQuestions: Yup.array().when(
                                        ["questionType", "descriptiveType"],
                                        {
                                            is: (qt, dt) => qt === "DESCRIPTIVE" && dt === "CHOICE_BASED",
                                            then: () =>
                                                Yup.array()
                                                    .of(
                                                        Yup.object({
                                                            questionText: Yup.string().required("Sub question text is required"),
                                                        })
                                                    )
                                                    .min(1, "At least one sub-question required")
                                                    .required("Sub questions required"),
                                            otherwise: () => Yup.array().notRequired(),
                                        }
                                    ),
                                })
                            )

                            /* 🔢 SECTION TOTAL = SUM OF QUESTION MARKS */
                            .test(
                                "section-total-marks",
                                "Sum of question marks must be exactly equal to section total marks",
                                function (questions) {
                                    const { totalMarks } = this.parent;

                                    if (!questions || questions.length === 0) return true;

                                    const sum = questions.reduce(
                                        (acc, q) => acc + (Number(q.marks) || 0),
                                        0
                                    );

                                    return sum === Number(totalMarks);
                                }
                            ),
                    })
                ),
            })
        ),



    })

    const { lmsGrade, lmsBoard, } = useLmsDropdownOptions({
        gradeFilter: { status: true },
        boardFilter: { status: true },
        boardFilter: { status: true }
    })

    const { assesmentSubjectType, coursesForAssessment } = useAssesmentDropdownOptions()
    const {  lmsSubject }=useLmsDropdownOptions({
        subjectFilter:{ status: "active" }
    })

    const mutationCreate = useMutation({
        mutationFn: (formData) => postCreateAssessment(formData),
    });

    const handleSubmit = (values, { setSubmitting, resetForm, setFieldValue }) => {

        mutationCreate.mutate(values, {
            onSuccess: () => {
                showToaster('Success', 'Ticket raised successfully!', 'success');
                resetForm()
            },
            onError: (err) => {
                showToaster('Error', err?.response?.data?.error || 'Failed', 'error');
            },
        });
    };

    const [activePaper, setActivePaper] = React.useState(0);

    return (


        <NormalContainerWithHeader headerText={"Add LMS"}>
            <Typography variant='h3' mb={1}>Baseline Assessment & Report Format</Typography>
            <Typography>Create and organize syllabus details for better course planning</Typography>
            <CustomDivider />
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ resetForm, values, setFieldValue }) => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap}>

                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.assessmentName`}
                                    component={TextFormField}
                                    label="Assessment Name"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.type`}
                                    component={AutoCompleteField}
                                    options={assesmentSubjectType?.options}
                                    label="Subject Type"
                                    isRequired={true}

                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.subjectId`}
                                    component={IdAutoCompleteField}
                                    options={  lmsSubject.options}
                                    label="Subject"
                                    isRequired={true}
                                    isLoading={lmsSubject.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.boardId`}
                                    component={IdAutoCompleteField}
                                    options={lmsBoard.options}
                                    label="Board"
                                    isRequired={true}
                                    isLoading={lmsBoard.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.gradeId`}
                                    component={IdAutoCompleteField}
                                    options={lmsGrade.options}
                                    label="Grade"
                                    isRequired={true}
                                    isLoading={lmsGrade.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.academicYear`}
                                    component={TextFormField}
                                    label="Academic Year"
                                    isRequired={true}
                                />
                            </Grid2>

                            {/* <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.academicYear`}
                                    component={TextFormField}
                                    label="Academic Year"
                                    isRequired={true}
                                />
                            </Grid2> */}
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name={`assessment.courseId`}
                                    component={IdAutoCompleteField}
                                    options={coursesForAssessment.options}
                                    label="Course"
                                    isRequired={true}
                                    isLoading={coursesForAssessment.isLoading}
                                />
                            </Grid2>



                        </Grid2>
                        <CustomDivider />
                        <Typography variant='h4' mb={2}>Create and organise assessment parameters  & marks</Typography>

                        <Box
                            sx={{
                                border: "1px solid #4169E1",
                                borderRadius: 1,
                            }}
                        >
                            <Grid2
                                sx={{
                                    py: 1.5, px: 2, borderBottom: "1px solid #4169E1"
                                }}
                                container
                                size={12}
                            >
                                <Grid2 size={3}>
                                    <Typography> Parameter</Typography>
                                </Grid2>
                                <Grid2 size={6}>
                                    <Typography> Subsplit</Typography>
                                </Grid2>
                                <Grid2 size={1}>
                                    <Typography> Mark</Typography>
                                </Grid2>

                            </Grid2>
                            <Box
                                sx={{ py: 1.5, px: 2, }}
                            >
                                <FieldArray name="parameters" >
                                    {({ push, remove }) => (
                                        <>
                                            {values.parameters.map((_, pIndex) => (
                                                <>
                                                    <CustomAccordion
                                                        key={pIndex}
                                                        summary={
                                                            <Grid2 container spacing={2} alignItems="center">
                                                                <Grid2 size={3}>
                                                                    <Field
                                                                        name={`parameters.${pIndex}.parameter`}
                                                                        component={FormikEditableText}
                                                                        placeholder="Parameter name"
                                                                    />
                                                                </Grid2>

                                                                <Grid2 size={6}>
                                                                    <Field
                                                                        name={`parameters.${pIndex}.description`}
                                                                        component={FormikEditableText}
                                                                        placeholder="Sub split"
                                                                    />
                                                                </Grid2>

                                                                <Grid2 size={1}>
                                                                    <Field
                                                                        name={`parameters.${pIndex}.maxMarks`}
                                                                        component={FormikEditableText}
                                                                        type="number"
                                                                        placeholder="Marks"
                                                                    />
                                                                </Grid2>
                                                                <Grid2 size={1}>



                                                                    <IconButton
                                                                        onClick={() => remove(pIndex)}
                                                                    >
                                                                        <Icon icon="material-symbols:delete-outline" width="24" height="24" color="#CB0505" />
                                                                    </IconButton>

                                                                </Grid2>
                                                            </Grid2>
                                                        }
                                                        details={
                                                            <>
                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Detailed Rubrics
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        bgcolor: "#fff",
                                                                        border: "1px solid #4169E1",
                                                                        borderRadius: 1
                                                                    }}
                                                                >
                                                                    <Grid2 container spacing={2}
                                                                        sx={{
                                                                            borderBottom: "1px solid #4169E1",
                                                                            py: 1.5, px: 2,
                                                                        }}
                                                                    >
                                                                        <Grid2 size={4}>
                                                                            <Typography>Performance Level</Typography>
                                                                        </Grid2>
                                                                        <Grid2 size={3}>
                                                                            <Typography>Score</Typography>
                                                                        </Grid2>
                                                                        <Grid2 size={4}>
                                                                            <Typography>Descriptor</Typography>
                                                                        </Grid2>
                                                                    </Grid2>
                                                                    <Grid2 container spacing={2}
                                                                        sx={{ py: 1.5, px: 2, }}
                                                                    >

                                                                        {values.parameters[pIndex].details.map((_, dIndex) => (
                                                                            <React.Fragment key={dIndex}>
                                                                                <Grid2 size={4}>
                                                                                    <Typography>
                                                                                        {values.parameters[pIndex].details[dIndex].performanceLevel}
                                                                                    </Typography>
                                                                                </Grid2>

                                                                                <Grid2 size={3} container gap={1}>
                                                                                    <Grid2 size={2}>
                                                                                        <Field
                                                                                            name={`parameters.${pIndex}.details.${dIndex}.minScore`}
                                                                                            component={FormikEditableText}
                                                                                            type="number"
                                                                                            placeholder={"min"}
                                                                                        />
                                                                                    </Grid2>
                                                                                    <Grid2 size={1}>
                                                                                        {" - "}
                                                                                    </Grid2>
                                                                                    <Grid2 size={2}>
                                                                                        <Field
                                                                                            name={`parameters.${pIndex}.details.${dIndex}.maxScore`}
                                                                                            component={FormikEditableText}
                                                                                            type="number"
                                                                                            placeholder={"max"}
                                                                                        />
                                                                                    </Grid2>
                                                                                </Grid2>

                                                                                <Grid2 size={4}>
                                                                                    <Field
                                                                                        name={`parameters.${pIndex}.details.${dIndex}.descriptor`}
                                                                                        component={FormikEditableText}
                                                                                        placeholder="Descriptor"
                                                                                    />
                                                                                </Grid2>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </Grid2>
                                                                </Box>
                                                            </>
                                                        }
                                                    />
                                                    <CustomDivider size={"0.5rem"} />
                                                </>


                                            ))}



                                            {/* ➕ Add Parameter Section */}
                                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => {
                                                        const newParam = { parameter: "", maxMarks: 0, description: "", details: DEFAULT_DETAILS };

                                                        // Add the parameter
                                                        const updatedParams = [...values.parameters, newParam];
                                                        setFieldValue("parameters", updatedParams);

                                                        // Add a blank section to EVERY question paper that matches this parameter
                                                        const updatedPapers = values.questionPapers.map(paper => ({
                                                            ...paper,
                                                            sections: [
                                                                ...paper.sections,
                                                                {
                                                                    title: "",
                                                                    totalMarks: 0,
                                                                    orderNo: updatedParams.length,
                                                                    isVisible: true,
                                                                    paragraph: "",
                                                                    questions: [MCQ_QUESTION]
                                                                }
                                                            ]
                                                        }));
                                                        setFieldValue("questionPapers", updatedPapers);
                                                    }}
                                                >
                                                    Add Parameter
                                                </Button>
                                            </Box>
                                        </>
                                    )}
                                </FieldArray>

                            </Box>


                        </Box>


                        <CustomDivider />

                        <Typography variant='h4' mb={1}>Session Timelines Recommendations</Typography>
                        <Typography mb={2}>Create and organize syllabus details for better course planning</Typography>


                        <Box

                            sx={{
                                border: "1px solid #4169E1",
                                borderRadius: 1,
                            }}
                        >
                            <Grid2
                                sx={{ py: 1.5, px: 2, borderBottom: "1px solid #4169E1" }}
                                container
                                size={12}
                            >
                                <Grid2 size={3}>
                                    <Typography>Category</Typography>
                                </Grid2>
                                <Grid2 size={4}>
                                    <Typography>Total Score</Typography>
                                </Grid2>
                                <Grid2 size={2}>
                                    <Typography>Time Line</Typography>
                                </Grid2>

                            </Grid2>
                            <Box
                                sx={{ py: 1.5, px: 2, }}
                            >
                                <FieldArray name="recommendations">
                                    {() => (
                                        <>
                                            {values.recommendations.map((rec, rIndex) => (

                                                <>
                                                    <CustomAccordion
                                                        key={rIndex}
                                                        summary={
                                                            <Grid2 container spacing={2} alignItems="center">
                                                                <Grid2 size={3}>
                                                                    <Typography fontWeight={600}>
                                                                        {rec.category}
                                                                    </Typography>
                                                                </Grid2>

                                                                <Grid2 size={4} container gap={1}>
                                                                    <Grid2 size={2}>
                                                                        <Field
                                                                            name={`recommendations.${rIndex}.minScore`}
                                                                            component={FormikEditableText}
                                                                            type="number"
                                                                            placeholder={"min"}
                                                                        />
                                                                    </Grid2>

                                                                    <Grid2 size={1}>  {" - "}</Grid2>

                                                                    <Grid2 size={2}>
                                                                        <Field
                                                                            name={`recommendations.${rIndex}.maxScore`}
                                                                            component={FormikEditableText}
                                                                            type="number"
                                                                            placeholder={"max"}
                                                                        />
                                                                    </Grid2>

                                                                </Grid2>

                                                                <Grid2 size={2}>
                                                                    <Field
                                                                        name={`recommendations.${rIndex}.timeline`}
                                                                        component={FormikEditableText}
                                                                    />
                                                                </Grid2>
                                                            </Grid2>
                                                        }
                                                        details={
                                                            <Box>

                                                                <Typography variant="subtitle2" mb={1}>
                                                                    Grade-wise Performance Analysis
                                                                </Typography>
                                                                <Box
                                                                    sx={{ bgcolor: "#fff", px: 1.5, py: 1, borderRadius: 1 }}
                                                                >
                                                                    <Typography variant="subtitle2" mb={-1}>
                                                                        Parents
                                                                    </Typography>

                                                                    <Field
                                                                        name={`recommendations.${rIndex}.recommendation`}
                                                                        component={TextFormField}
                                                                        multiline
                                                                        rows={3}
                                                                        placeholder="Write something..."
                                                                    />
                                                                </Box>


                                                                <CustomDivider size={"0.5rem"} />
                                                                <Box
                                                                    sx={{ bgcolor: "#fff", px: 1.5, py: 1, borderRadius: 1 }}
                                                                >


                                                                    <FieldArray name={`recommendations.${rIndex}.grades`}>
                                                                        {({ push, remove }) => (
                                                                            <>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        mb: 1
                                                                                    }}
                                                                                >
                                                                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                                                                        <Typography variant="subtitle2">AI</Typography>
                                                                                    </Box>
                                                                                    <Button
                                                                                        variant='outlined'
                                                                                        startIcon={<AddIcon />}
                                                                                        onClick={() =>
                                                                                            push({
                                                                                                gradeName: "",
                                                                                                gradeTags: []
                                                                                            })
                                                                                        }
                                                                                    >
                                                                                        Add Grade
                                                                                    </Button>
                                                                                </Box>


                                                                                {rec.grades.map((_, gIndex) => (
                                                                                    <>
                                                                                        <CustomAccordion
                                                                                            key={gIndex}
                                                                                            summary={
                                                                                                <Box
                                                                                                    display="flex"
                                                                                                    justifyContent="space-between"
                                                                                                    alignItems="center"
                                                                                                >
                                                                                                    <Field
                                                                                                        name={`recommendations.${rIndex}.grades.${gIndex}.gradeName`}
                                                                                                        component={FormikEditableText}
                                                                                                        placeholder="Grade name"
                                                                                                    />

                                                                                                    <Box pr={5}>

                                                                                                        <IconButton onClick={() => remove(gIndex)}>
                                                                                                            <Icon icon="material-symbols:delete-outline" width="24" height="24" color="#CB0505" />
                                                                                                        </IconButton>
                                                                                                    </Box>
                                                                                                </Box>
                                                                                            }
                                                                                            details={
                                                                                                <FieldArray
                                                                                                    name={`recommendations.${rIndex}.grades.${gIndex}.gradeTags`}
                                                                                                >
                                                                                                    {({ push: pushTag, remove: removeTag }) => (
                                                                                                        <Box>
                                                                                                            {rec.grades[gIndex].gradeTags.map((_, tIndex) => (
                                                                                                                <Grid2
                                                                                                                    key={tIndex}
                                                                                                                    display="flex"
                                                                                                                    gap={1}
                                                                                                                    mb={1}
                                                                                                                    container
                                                                                                                    spacing={5}
                                                                                                                >
                                                                                                                    <Grid2 size={1}>

                                                                                                                    </Grid2>
                                                                                                                    <Grid2 size={10}>
                                                                                                                        <Field
                                                                                                                            name={`recommendations.${rIndex}.grades.${gIndex}.gradeTags.${tIndex}`}
                                                                                                                            component={FormikEditableText}
                                                                                                                            placeholder="Tag"
                                                                                                                        />
                                                                                                                    </Grid2>
                                                                                                                    <Grid2 size={1}>
                                                                                                                        <Button
                                                                                                                            variant='outlined'
                                                                                                                            onClick={() => removeTag(tIndex)}
                                                                                                                            fullWidth
                                                                                                                            style={{ border: "1px solid #CD0000" }}

                                                                                                                        >
                                                                                                                            <ClearIcon sx={{ color: "#CD0000" }} />
                                                                                                                        </Button>
                                                                                                                    </Grid2>
                                                                                                                </Grid2>
                                                                                                            ))}

                                                                                                            <Button
                                                                                                                variant='outlined'
                                                                                                                onClick={() => pushTag("")}
                                                                                                            >
                                                                                                                + Add Tag
                                                                                                            </Button>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                </FieldArray>
                                                                                            }
                                                                                        />
                                                                                        <CustomDivider size={"1rem"} />
                                                                                    </>
                                                                                ))}


                                                                            </>
                                                                        )}
                                                                    </FieldArray>
                                                                </Box>
                                                            </Box>
                                                        }
                                                    />
                                                    <CustomDivider size={"1rem"} />
                                                </>
                                            ))}
                                        </>
                                    )}
                                </FieldArray>
                            </Box>
                        </Box>


                        <CustomDivider />


                        <Typography variant='h4' mb={1}>Create Assessment Questions</Typography>
                        <Typography mb={2}>Add Assessment questions and change the name accordingly</Typography>

                        <FieldArray name="questionPapers">
                            {({ push: pushPaper, remove: removePaper }) => (
                                <>
                                    {/* Tabs for switching between Question Papers */}
                                    <Box display="flex" alignItems="center">
                                        <Tabs
                                            value={activePaper}
                                            onChange={(_, val) => setActivePaper(val)}
                                            indicatorColor="transparent"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            sx={{
                                                flexGrow: 1,
                                                "& .MuiTabs-flexContainer": { flexWrap: "nowrap" },
                                            }}
                                        >

                                            {/* {values.questionPapers.map((paper, pIndex) => (
                                                <Tab
                                                    key={pIndex}
                                                    sx={{
                                                        minWidth: "100px",
                                                        borderBottom: activePaper === pIndex ? "4px solid #4169E1" : "none",
                                                        background: activePaper === pIndex
                                                            ? "linear-gradient(175deg, #FFFFFF 18%, #4169E1 140%)"
                                                            : "#E3ECFF",
                                                        borderRadius: "8px 8px 0 0",
                                                        mx: 0.5,
                                                    }}
                                                    label={
                                                        <Field
                                                            name={`questionPapers.${pIndex}.paperName`}
                                                            component={FormikEditableText}
                                                            placeholder={`Question Paper ${pIndex + 1}`}
                                                        />
                                                    }
                                                />
                                            ))} */}
                                            {values.questionPapers.map((paper, pIndex) => (
                                                <Tab
                                                    key={pIndex}

                                                    sx={{
                                                        minWidth: "120px",

                                                        // 🔵 Active underline (dark blue)
                                                        borderBottom: activePaper === pIndex ? "4px solid #0D2A6B" : "none",

                                                        // 🎨 Background
                                                        background:
                                                            activePaper === pIndex
                                                                ? "linear-gradient(180deg, #FFFFFF 0%, #D6E3FF 100%)" // light blue fade
                                                                : "#EAF1FF", // light inactive blue

                                                        borderRadius: "8px 8px 0 0",

                                                        // 🔤 Text color
                                                        color: activePaper === pIndex ? "#4169E1" : "#3A4A7A",
                                                        fontWeight: activePaper === pIndex ? 600 : 500,

                                                        mx: 0.5,
                                                        position: "relative",

                                                        // 👇 show delete icon on hover
                                                        "&:hover .delete-icon": {
                                                            opacity: 1,
                                                        },
                                                    }}
                                                    label={
                                                        <Box position="relative" pr={2}>
                                                            <Field
                                                                name={`questionPapers.${pIndex}.paperName`}
                                                                component={FormikEditableText}
                                                                placeholder={`Question Paper ${pIndex + 1}`}
                                                            />

                                                            {/* ❌ Delete Icon */}
                                                            <IconButton
                                                                className="delete-icon"
                                                                size="small"
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // ✅ prevent tab switch
                                                                    removePaper(pIndex);       // FieldArray remove
                                                                    if (activePaper === pIndex && pIndex > 0) {
                                                                        setActivePaper(pIndex - 1);
                                                                    }
                                                                }}
                                                                sx={{
                                                                    position: "absolute",
                                                                    top: -6,
                                                                    right: -10,
                                                                    bgcolor: "#000",
                                                                    color: "#fff",
                                                                    width: 18,
                                                                    height: 18,
                                                                    opacity: 0, // hidden by default
                                                                    transition: "opacity 0.2s ease, background-color 0.2s ease",
                                                                    "&:hover": {
                                                                        bgcolor: "#CD0000",
                                                                    },
                                                                }}
                                                            >
                                                                <ClearIcon sx={{ fontSize: 14 }} />
                                                            </IconButton>
                                                        </Box>
                                                    }
                                                />
                                            ))}

                                        </Tabs>

                                        <Button
                                            startIcon={<AddIcon />}
                                            variant="contained"

                                            onClick={() => {
                                                pushPaper({
                                                    paperName: `Question Paper ${values.questionPapers.length + 1}`,
                                                    paperNo: values.questionPapers.length + 1,
                                                    sections: values.parameters.map((p, idx) => ({
                                                        title: p.parameter,
                                                        totalMarks: p.maxMarks,
                                                        orderNo: idx + 1,
                                                        isVisible: true,
                                                        paragraph: "",
                                                        questions: [MCQ_QUESTION]
                                                    })),
                                                });
                                                setActivePaper(values.questionPapers.length);
                                            }}
                                        >
                                            Add More Paper
                                        </Button>
                                    </Box>

                                    <CustomDivider />


                                    {values.questionPapers.map((paper, pIndex) => (
                                        activePaper === pIndex && (
                                            <Box key={pIndex}>

                                                {values.parameters.map((param, sIndex) => {

                                                    const sectionPath = `questionPapers.${pIndex}.sections.${sIndex}`;

                                                    return (
                                                        <Box key={sIndex} mb={3}>
                                                            <CustomOurlineAccordian
                                                                summary={
                                                                    <Grid2 container spacing={2} alignItems="center">
                                                                        <Grid2 size={7}>
                                                                            {/* <Typography variant='h4' mb={0.5}>
                                                                                {param.parameter || `Section ${sIndex + 1}`}
                                                                            </Typography> */}
                                                                            <Field
                                                                                name={`${sectionPath}.title`}
                                                                                component={FormikEditableText}
                                                                                placeholder={`Section ${sIndex + 1}`}
                                                                                value={param.parameter}
                                                                                disabled
                                                                            />
                                                                            <Typography variant="body2">{param.description}</Typography>
                                                                        </Grid2>
                                                                        <Grid2 size={3}>
                                                                            {/* <Typography variant='h4'>Marks: {param.maxMarks}</Typography> */}
                                                                            <Field
                                                                                name={`${sectionPath}.totalMarks`}
                                                                                component={FormikEditableText}
                                                                                disabled
                                                                                placeholder={`Mark`}
                                                                                value={param.maxMarks}
                                                                            />
                                                                        </Grid2>
                                                                    </Grid2>
                                                                }
                                                                details={
                                                                    <Box>
                                                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                            <Typography variant="h5">{param.parameter} Passage</Typography>
                                                                            <Field name={`${sectionPath}.isVisible`}>
                                                                                {({ field, form }) => (
                                                                                    <ToggleSwitch
                                                                                        checked={field.value}
                                                                                        onCheck={(val) => form.setFieldValue(field.name, val)}
                                                                                        checkedText={"Visible to Student"}
                                                                                        unCheckedText={"Hidden"}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </Box>

                                                                        <CustomDivider size={"1rem"} />


                                                                        <Grid2 size={12}>
                                                                            <Typography variant='body2' fontWeight={300}>Instructions / Passage</Typography>
                                                                            <Field
                                                                                name={`${sectionPath}.paragraph`}
                                                                                component={TextFormField}
                                                                                multiline
                                                                                rows={4}
                                                                                placeholder={`Enter passage for ${param.parameter}...`}
                                                                            />
                                                                        </Grid2>

                                                                        <CustomDivider />


                                                                        <FieldArray name={`${sectionPath}.questions`}>
                                                                            {({ push: pushQuestion, remove: removeQuestion }) => (
                                                                                <>
                                                                                    {values.questionPapers[pIndex]?.sections?.[sIndex]?.questions?.map((question, qIndex) => {
                                                                                        const questionPath = `${sectionPath}.questions.${qIndex}`;

                                                                                        return (
                                                                                            <Box
                                                                                                key={qIndex}
                                                                                                p={2}
                                                                                                mb={2}
                                                                                                borderRadius={2}
                                                                                                sx={{
                                                                                                    border: "1px solid #ddd",
                                                                                                    position: "relative"
                                                                                                }}

                                                                                            >
                                                                                                <IconButton
                                                                                                    onClick={() => removeQuestion(qIndex)}
                                                                                                    sx={{
                                                                                                        position: "absolute",
                                                                                                        top: 10,
                                                                                                        right: 10,
                                                                                                        bgcolor: "#000",        // ✅ before hover
                                                                                                        p: 0,
                                                                                                        transition: "background-color 0.3s ease",
                                                                                                        "&:hover": {
                                                                                                            bgcolor: "#CD0000", // ✅ on hover
                                                                                                        },
                                                                                                    }}
                                                                                                >
                                                                                                    <ClearIcon sx={{ color: "#fff" }} />
                                                                                                </IconButton>

                                                                                                <Typography variant='h5' fontWeight={400} mb={1}>Question {qIndex + 1}</Typography>

                                                                                                <RadioButtonGroup
                                                                                                    row
                                                                                                    options={[
                                                                                                        { label: "MCQ", value: "MCQ" },
                                                                                                        { label: "Descriptive", value: "DESCRIPTIVE" },
                                                                                                    ]}
                                                                                                    value={question.questionType}
                                                                                                    onChange={(val) =>
                                                                                                        setFieldValue(questionPath, val === "MCQ" ? MCQ_QUESTION : DESCRIPTIVE_INDIVIDUAL)
                                                                                                    }
                                                                                                />

                                                                                                <CustomDivider />


                                                                                                {question.questionType === "MCQ" && (
                                                                                                    <>
                                                                                                        <Typography variant='h5' mb={2}>Add the question here</Typography>
                                                                                                        <Field
                                                                                                            name={`${questionPath}.questionText`}
                                                                                                            component={TextFormField}
                                                                                                            label="Question"
                                                                                                        />
                                                                                                        <CustomDivider />
                                                                                                        <FieldArray name={`${questionPath}.options`}>
                                                                                                            {() => (
                                                                                                                <>
                                                                                                                    <Typography variant='h5' mb={2}>Add the options and choose the right answer</Typography>
                                                                                                                    {question?.options?.map((_, oIndex) => (
                                                                                                                        <Grid2 container spacing={2} key={oIndex} mb={2}>

                                                                                                                            <Grid2 size={0.5} pt={4}>
                                                                                                                                <Field
                                                                                                                                    name={`${questionPath}.options.${oIndex}.isCorrect`}
                                                                                                                                    component={RadioCorrectField}

                                                                                                                                    values={values}
                                                                                                                                />
                                                                                                                            </Grid2>

                                                                                                                            <Grid2 size={1}>


                                                                                                                                <IndexComponent
                                                                                                                                    label={`No`}
                                                                                                                                    value={oIndex + 1}
                                                                                                                                />
                                                                                                                            </Grid2>
                                                                                                                            <Grid2 size={10.5}>
                                                                                                                                <Field
                                                                                                                                    name={`${questionPath}.options.${oIndex}.optionText`}
                                                                                                                                    component={TextFormField}
                                                                                                                                    label={`Option ${String.fromCharCode(65 + oIndex)}`}
                                                                                                                                />
                                                                                                                            </Grid2>


                                                                                                                        </Grid2>
                                                                                                                    ))}
                                                                                                                </>
                                                                                                            )}
                                                                                                        </FieldArray>

                                                                                                    </>
                                                                                                )}

                                                                                                {/* Descriptive Specific Logic */}
                                                                                                {question.questionType === "DESCRIPTIVE" && (
                                                                                                    <>

                                                                                                        <Typography variant='h5' fontWeight={200} mb={1}>Choose the type of descriptive question</Typography>

                                                                                                        <RadioButtonGroup
                                                                                                            row
                                                                                                            options={[
                                                                                                                { label: "Individual", value: "INDIVIDUAL" },
                                                                                                                { label: "Choice Based", value: "CHOICE_BASED" },
                                                                                                            ]}
                                                                                                            value={question.descriptiveType}
                                                                                                            onChange={(val) =>
                                                                                                                setFieldValue(
                                                                                                                    questionPath,
                                                                                                                    val === "INDIVIDUAL"
                                                                                                                        ? DESCRIPTIVE_INDIVIDUAL
                                                                                                                        : DESCRIPTIVE_CHOICE_BASED
                                                                                                                )
                                                                                                            }
                                                                                                        />
                                                                                                        <CustomDivider />

                                                                                                        {/* Individual */}
                                                                                                        {question.descriptiveType === "INDIVIDUAL" && (
                                                                                                            <Grid2 container>
                                                                                                                <Grid2 size={12}>
                                                                                                                    <Typography variant='h5' mb={2}>Add the question here</Typography>
                                                                                                                </Grid2>
                                                                                                                <Grid2 size={12} container spacing={2}>
                                                                                                                    <Grid2 size={1}>


                                                                                                                        <IndexComponent
                                                                                                                            label={"No"}
                                                                                                                            value={"1"}
                                                                                                                        />
                                                                                                                    </Grid2>
                                                                                                                    <Grid2 size={11}>
                                                                                                                        <Field
                                                                                                                            name={`${questionPath}.questionText`}
                                                                                                                            component={TextFormField}
                                                                                                                            label="Question"
                                                                                                                        />
                                                                                                                    </Grid2>
                                                                                                                </Grid2>

                                                                                                            </Grid2>
                                                                                                        )}

                                                                                                        {/* Choice Based */}
                                                                                                        {question.descriptiveType === "CHOICE_BASED" && (

                                                                                                            <>
                                                                                                                <Typography variant='h5' mb={2}>Add the question here</Typography>
                                                                                                                <Grid2 size={12}>
                                                                                                                    <Field
                                                                                                                        name={`${questionPath}.subQuestionHeading`}
                                                                                                                        component={TextFormField}
                                                                                                                        label={`Question`}
                                                                                                                    />
                                                                                                                </Grid2>
                                                                                                                <CustomDivider size={"1rem"} />
                                                                                                                <FieldArray name={`${questionPath}.subQuestions`}>
                                                                                                                    {({ push: pushChoice, remove: removeChoice }) => (
                                                                                                                        <>
                                                                                                                            <Grid2 size={12}>
                                                                                                                                <Typography variant='h5' mb={2}>Add the choice questions</Typography>
                                                                                                                            </Grid2>
                                                                                                                            {question?.subQuestions?.map((_, sIndex) => (
                                                                                                                                <Box key={sIndex} mb={2}>
                                                                                                                                    <Grid2 size={12} container spacing={2} sx={{ alignItems: "end", display: "flex" }}>
                                                                                                                                        <Grid2 size={1}>
                                                                                                                                            <IndexComponent
                                                                                                                                                label={`No`}
                                                                                                                                                value={sIndex + 1}
                                                                                                                                            />

                                                                                                                                        </Grid2>
                                                                                                                                        <Grid2 size={10}>
                                                                                                                                            <Field
                                                                                                                                                name={`${questionPath}.subQuestions.${sIndex}.questionText`}
                                                                                                                                                component={TextFormField}
                                                                                                                                                label={`Choice ${String.fromCharCode(65 + sIndex)}`}
                                                                                                                                            />
                                                                                                                                        </Grid2>


                                                                                                                                        {question?.subQuestions?.length - 1 != sIndex &&
                                                                                                                                            <Grid2 size={1}>
                                                                                                                                                <Button
                                                                                                                                                    variant='outlined'
                                                                                                                                                    onClick={() =>
                                                                                                                                                        removeChoice(sIndex)
                                                                                                                                                    }
                                                                                                                                                    fullWidth
                                                                                                                                                    style={{ border: "1px solid #CD0000" }}

                                                                                                                                                >
                                                                                                                                                    <ClearIcon sx={{ color: "#CD0000" }} />
                                                                                                                                                </Button>
                                                                                                                                            </Grid2>

                                                                                                                                        }

                                                                                                                                        {question?.subQuestions?.length - 1 == sIndex &&
                                                                                                                                            <Grid2 size={1}>
                                                                                                                                                <Button
                                                                                                                                                    variant='outlined'
                                                                                                                                                    onClick={() =>
                                                                                                                                                        pushChoice({ questionText: "", })
                                                                                                                                                    }
                                                                                                                                                    fullWidth
                                                                                                                                                >
                                                                                                                                                    <AddIcon />
                                                                                                                                                </Button>
                                                                                                                                            </Grid2>

                                                                                                                                        }

                                                                                                                                    </Grid2>


                                                                                                                                </Box>
                                                                                                                            ))}
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </FieldArray>

                                                                                                            </>
                                                                                                        )}

                                                                                                    </>
                                                                                                )}

                                                                                                <Grid2 container spacing={2} mt={2}>
                                                                                                    <Typography variant='h5' mb={2}>Add the mark for right answer</Typography>
                                                                                                    <Field
                                                                                                        name={`${questionPath}.marks`}
                                                                                                        component={TextFormField}
                                                                                                        label="Marks"
                                                                                                        type="number"
                                                                                                    />
                                                                                                </Grid2>
                                                                                            </Box>
                                                                                        );
                                                                                    })}

                                                                                    <Button
                                                                                        startIcon={<AddIcon />}
                                                                                        variant="outlined"
                                                                                        onClick={() => pushQuestion(MCQ_QUESTION)}
                                                                                    >
                                                                                        Add Question
                                                                                    </Button>
                                                                                </>
                                                                            )}
                                                                        </FieldArray>
                                                                    </Box>
                                                                }
                                                            />
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                        )
                                    ))}
                                </>
                            )}
                        </FieldArray>
                        <CustomDivider />
                        <Grid2 container spacing={Grid_Gap} mt={2}>
                            <Grid2 children size={Input_Width}>
                                <Button
                                    variant="outlined"
                                    type="button"
                                    onClick={() => {
                                        resetForm();
                                    }}
                                    fullWidth
                                >
                                    Reset
                                </Button>
                            </Grid2>
                            <Grid2 children size={Input_Width}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    fullWidth
                                >
                                    Submit
                                </Button>
                            </Grid2>

                        </Grid2>

                    </Form>
                )}
            </Formik>
        </NormalContainerWithHeader>
    )
}

export default CreatAssesments

const payload = {
    "assessment": {
        "assessmentName": "assesment",
        "type": "LANGUAGE",
        "subjectId": "1",
        "boardId": 1,
        "gradeId": 1,
        "academicYear": "2025",
        "status": "DRAFT",
        "courseId": "28"
    },
    "parameters": [
        {
            "parameter": "reading skill",
            "maxMarks": 20,
            "description": "sub split reading",
            "details": [
                {
                    "performanceLevel": "Below_Average",
                    "minScore": 6,
                    "maxScore": 10,
                    "descriptor": "test"
                },
                {
                    "performanceLevel": "Average",
                    "minScore": 1,
                    "maxScore": 13,
                    "descriptor": "test"
                },
                {
                    "performanceLevel": "Above_Average",
                    "minScore": 14,
                    "maxScore": 20,
                    "descriptor": "test"
                }
            ]
        }
    ],
    "recommendations": [
        {
            "minScore": 1,
            "maxScore": 10,
            "category": "Below_Average",
            "timeline": "3 Weeks",
            "recommendation": "test",
            "grades": [
                {
                    "gradeName": "grad1",
                    "gradeTags": [
                        "tag1"
                    ]
                }
            ]
        },
        {
            "minScore": 11,
            "maxScore": 14,
            "category": "Average",
            "timeline": "2 Weeks",
            "recommendation": "test",
            "grades": [
                {
                    "gradeName": "grad2",
                    "gradeTags": [
                        "tag1"
                    ]
                }
            ]
        },
        {
            "minScore": 14,
            "maxScore": 20,
            "category": "Above_Average",
            "timeline": "1 Weeks",
            "recommendation": "test",
            "grades": [
                {
                    "gradeName": "grade3",
                    "gradeTags": [
                        "tag3"
                    ]
                }
            ]
        }
    ],
    "questionPapers": [
        {
            "paperName": "question 1",
            "paperNo": 1,
            "sections": [
                {
                    "title": "reading skill",
                    "totalMarks": 20,
                    "orderNo": 1,
                    "isVisible": true,
                    "paragraph": "reaidn para",
                    "questions": [
                        {
                            "questionType": "MCQ",
                            "questionText": "test msq",
                            "marks": 18,
                            "orderNo": 1,
                            "options": [
                                {
                                    "optionText": "test",
                                    "isCorrect": true,
                                    "orderNo": 1
                                },
                                {
                                    "optionText": "test",
                                    "isCorrect": false,
                                    "orderNo": 2
                                },
                                {
                                    "optionText": "test",
                                    "isCorrect": false,
                                    "orderNo": 3
                                },
                                {
                                    "optionText": "test",
                                    "isCorrect": false,
                                    "orderNo": 4
                                }
                            ]
                        },
                        {
                            "questionType": "DESCRIPTIVE",
                            "descriptiveType": "INDIVIDUAL",
                            "questionText": "test",
                            "marks": 1,
                            "orderNo": 1
                        },
                        {
                            "questionType": "DESCRIPTIVE",
                            "descriptiveType": "CHOICE_BASED",
                            "questionText": "",
                            "marks": 1,
                            "orderNo": 1,
                            "subQuestionHeading": "test",
                            "subQuestions": [
                                {
                                    "questionText": "test1"
                                },
                                {
                                    "questionText": "test1"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "paperName": "Qeustion2",
            "paperNo": 2,
            "sections": [
                {
                    "title": "reading skill",
                    "totalMarks": 20,
                    "orderNo": 1,
                    "isVisible": true,
                    "paragraph": "reaidng para",
                    "questions": [
                        {
                            "questionType": "MCQ",
                            "questionText": "test",
                            "marks": 18,
                            "orderNo": 1,
                            "options": [
                                {
                                    "optionText": "test1",
                                    "isCorrect": true,
                                    "orderNo": 1
                                },
                                {
                                    "optionText": "test2",
                                    "isCorrect": false,
                                    "orderNo": 2
                                },
                                {
                                    "optionText": "test3",
                                    "isCorrect": false,
                                    "orderNo": 3
                                },
                                {
                                    "optionText": "test4",
                                    "isCorrect": false,
                                    "orderNo": 4
                                }
                            ]
                        },
                        {
                            "questionType": "DESCRIPTIVE",
                            "descriptiveType": "INDIVIDUAL",
                            "questionText": "test",
                            "marks": 1,
                            "orderNo": 1
                        },
                        {
                            "questionType": "DESCRIPTIVE",
                            "descriptiveType": "CHOICE_BASED",
                            "questionText": "",
                            "marks": 1,
                            "orderNo": 1,
                            "subQuestionHeading": "test",
                            "subQuestions": [
                                {
                                    "questionText": "test1"
                                },
                                {
                                    "questionText": "test2"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "paperName": "Question3",
            "paperNo": 3,
            "sections": [
                {
                    "title": "reading skill",
                    "totalMarks": 20,
                    "orderNo": 1,
                    "isVisible": true,
                    "paragraph": "reaidng paor",
                    "questions": [
                        {
                            "questionType": "MCQ",
                            "questionText": "test1",
                            "marks": 18,
                            "orderNo": 1,
                            "options": [
                                {
                                    "optionText": "test1",
                                    "isCorrect": true,
                                    "orderNo": 1
                                },
                                {
                                    "optionText": "test2",
                                    "isCorrect": false,
                                    "orderNo": 2
                                },
                                {
                                    "optionText": "test3",
                                    "isCorrect": false,
                                    "orderNo": 3
                                },
                                {
                                    "optionText": "test4",
                                    "isCorrect": false,
                                    "orderNo": 4
                                }
                            ]
                        },
                        {
                            "questionType": "DESCRIPTIVE",
                            "descriptiveType": "INDIVIDUAL",
                            "questionText": "test",
                            "marks": 1,
                            "orderNo": 1
                        },
                        {
                            "questionType": "DESCRIPTIVE",
                            "descriptiveType": "CHOICE_BASED",
                            "questionText": "",
                            "marks": 1,
                            "orderNo": 1,
                            "subQuestionHeading": "test",
                            "subQuestions": [
                                {
                                    "questionText": "test1"
                                },
                                {
                                    "questionText": "test2"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}